import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router';

function ConsumersQuickAccessForm() {
  const navigate = useNavigate();

  return (
    <Form.Control
      className="bo-input bo-w-120"
      name="quickAccess"
      id="quickAccess"
      placeholder="Consumer ID"
      onKeyDown={e => {
        if (e.code === 'Enter' && e.target.value !== '') {
          navigate(`/consumer/${e.target.value}`);
        }
      }}
    />
  );
}

export default ConsumersQuickAccessForm;
